// ** Toolkit imports
import { configureStore } from '@reduxjs/toolkit';

// ** Reducers
import billView from './bill-view/index';
import billValidation from './bill-validation/index';
import accountingData from './accounting/index';
import original2BData from './original2b-bills/index';
import challan from './challan/index';
import challanType from './challan-type/index';
import navbarUpdate from './navbar/index';
import flyAsh from './fly-ash/index';

export const store = configureStore({
  reducer: {
    billView,
    billValidation,
    accountingData,
    original2BData,
    challan,
    challanType,
    flyAsh,
    navbarUpdate
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
